var e = !!(typeof window < "u" && window.document && window.document.createElement);
export {
  e as i
};
